<template>
    <ModalWrapper
        v-model="modal"
        theme="light"
        :loading="hotelsLoading"
        :content-class="{'overflow-y-hidden': true}"
        max-width="622"
    >
        <template v-slot:activator="{props}">
            <v-btn
                v-if="!isMobile"
                v-bind="props"
                variant="text"
                theme="dark"
                class="text-none font-weight-regular"
                color="inherit"
                @click="loadHotels"
            >
                {{ $t('view_on_map') }}
            </v-btn>
            <v-btn v-else icon="mdi-map" variant="text" v-bind="props" @click="loadHotels" />
        </template>
        <template v-slot:title>
            {{ $t('view_on_map') }}
        </template>
        <template v-slot:content>
            <hotel-map-modified
                v-if="!hotelsLoading"
                v-model="mapExpanded"
                style="position: unset; max-height: 600px"
                :offers="hotels"
                :parent="true"
            />
        </template>
    </ModalWrapper>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import HotelMapModified from '@/components/search/offers/HotelMapModified.vue'

    @Component({
        components: {HotelMapModified},
    })
    export class OwnHotelMapModal extends Vue {
        mapExpanded = false
        hotels = []
        modal = false
        hotelsLoading = false

        async loadHotels() {
            try {
                this.hotelsLoading = true
                const limit = 500
                let offset = 0

                const firstResponse = await this.$api.hotels.get({limit, offset, contentProviderId: 1})
                const countTotal = firstResponse.count

                this.hotels = [...firstResponse.hotels]

                const totalRequests = Math.ceil(countTotal / limit)

                for (let i = 1; i < totalRequests; i++) {
                    offset = i * limit
                    const response = await this.$api.hotels.get({limit, offset})
                    this.hotels = this.hotels.concat([...response.hotels])
                }
            } catch {
                this.$toast.error(this.$t('error_message.load_error'))
                this.hotels = []
                this.modal = false
            } finally {
                this.hotelsLoading = false
            }
        }

        get isMobile() {
            return this.$breakpoint.smAndDown
        }
    }

    export default OwnHotelMapModal
</script>
